var _module = require('../components/module');
var numAbbr = require('number-abbreviate')();

/*
numberAbbreviate
Changes a number to an abbreviated version. ex. 350k
*/
_module.filter('numberAbbreviate', function () {
    return function numberAbbreviate(str, decPlaces) {
        return numAbbr.abbreviate(str, decPlaces || 0);
    };
});
